/*
 * @Descripttion:
 * @Author: voanit
 * @Date: 2022-02-10 14:02:49
 * @LastEditors: voanit
 * @LastEditTime: 2022-03-03 19:27:41
 */
import 'es6-promise/auto'
import Vue from 'vue' //引入vue
import Vuex from 'vuex' //引入vuex
import axios from 'axios'
import util from 'util'
import $ from 'jquery'
Vue.use(Vuex); //使用 vuex

export default new Vuex.Store({
    state: {
      page:{
        pageSize:10,
        total:0
      },
      currentPage:1,
      academicCircle:[]
      // 初始化状态
      // currentUser: null,
      // isLogin: false,
      // token: "",
      // expertId: null,
      // dirID:null
    },
    mutations: {
      changePageSize(state,val){
        state.currentPage = val
        console.log(state,'大萨达撒',val)

      },
      getList(state,val){
        console.log(state,'qwewqe')
        var params = new URLSearchParams();
        params.append("JournalID", 202208020001); //期刊ID，固定不变
        params.append("ChannelID", val);
        params.append("PageSize", state.pageSize); //每页条数
        params.append("CurrentPage", state.currentPage); //当前页
        axios.post("/SiteContentAPI/GetPageList", params).then((res) => {
          state.academicCircle = res.data._itemList;
          state.academicCircle.forEach((item) => {
            item.AddDate = item.AddDate.substr(0, 10);
            // item.TitlePhoto = this.lmUrl + item.TitlePhoto
            item.TitlePhoto = item.TitlePhoto;
          });
          state.page.total = res.data.totalRecords;
        });
        console.log(state.academicCircle,'萨达')
      }
        // 处理状态
        // userStatus: (state, user) => {
        //     if (user) {
        //         state.currentUser = user;
        //         state.isLogin = true;

        //     } else if (user == null) {
        //         //sessionStorage.setItem("expertId",null);
        //     }
        // },
        // idStatus: (state, id) => {
        //     if (id) {
        //         state.expertId = id;
        //     } else if (id == null) {
        //         sessionStorage.setItem("expertId", null);
        //     }
        // },
        // userStatus(state,payload){
        //     state.expertId = payload
        // },
        // idStatus(state,payload){
        //     state.dirID = payload
        // }

    },
    actions: {
      getNavList(store,ChannelID){
        store.state.page.currentPage = 1
        store.commit('getList',ChannelID)
        console.log(store,'88888888',ChannelID)
      }
        //处理列表项
        // async EXPERID(context){
        //   console.log(context);
        //   // var expertId = localStorage.getItem("expertId");
        //   await axios.post('/api/Bw/GetliefDir?expertId=2').then((res =>{
        //     var obj = res.data.Data
        //     // obj.forEach(e => {
        //     //   // (function (i) {
        //     //     context.commit('userStatus',e.ExpertId);
        //     //     context.commit('idStatus',e.Id)
        //     //   // })(i)
        //     // })
        //     var arr = []
        //     for (var i = 0; i < obj.length; i++) {
        //       arr.push({"dirID": obj[i].Id, "expertId": obj[i].ExpertId})
        //     }
        //     context.commit('userStatus',arr);
        //     context.commit('idStatus',arr)
        //   }))
        // }
    },
    getters: {
        // 提交改变后的状态
        // expertId:function(state){
        //     return state.expertId
        // },
        // dirID:function(state){
        //   return state.dirID
        // }
    },
})



// WEBPACK FOOTER //
// ./src/store/index.js